module.exports = __webpack_public_path__ + "media/images/athletes/2389-592e79dcef7804512ea4f3527bd172f4.png";